import {
	showBVNModal,
	showCertModal,
	showPerInfoModal,
	showProofModal,
	showVideoModal,
} from "../../../redux/kyc/generalSlice";
import { getComplianceState } from "../../../redux/kyc/getcomplianceSlice";
import { useDispatch, useSelector } from "react-redux";
import { CompliceStatus } from "./CompliceStatus";

export const Document = () => {
	const dispatch = useDispatch();
	const { business_compliance_data: busComData } =
		useSelector(getComplianceState);
	const personalDocStatus = busComData?.data?.personal_document_verify_status;
	const BVNStatus = busComData?.data?.bvn_verify_status;
	const videoStatus = busComData?.data?.video_confirmation_verify_status;
	const addressStatus = busComData?.data?.proof_of_address_verify_status;
	const certStatus =
		busComData?.data?.certificate_of_incorporation_verify_status;
	const business_name = busComData?.data?.business_name;

	return (
		<div className="profile">
			<div className="header">
				<h3>Document</h3>
				<p>Please Upload All Documents</p>
			</div>
			<div>
				<div className="docs">
					<h5>Personal Information Document</h5>
					<span
						className={`bs-plus ${personalDocStatus?.toLowerCase()}`}
						onClick={
							personalDocStatus === "REJECTED" ||
							personalDocStatus === null ||
							personalDocStatus === ""
								? () => dispatch(showPerInfoModal())
								: () => {}
						}
					>
						<CompliceStatus status={personalDocStatus} />
					</span>
				</div>
				<div className="docs">
					<h5>BVN (Compulsory)</h5>
					<span
						className={`bs-plus ${BVNStatus?.toLowerCase()}`}
						onClick={
							BVNStatus === "REJECTED" ||
							BVNStatus === null ||
							BVNStatus === ""
								? () => dispatch(showBVNModal())
								: () => {}
						}
					>
						<CompliceStatus status={BVNStatus} />
					</span>
				</div>
				<div className="docs">
					<h5>Video Confirmation</h5>
					<span
						className={`bs-plus ${videoStatus?.toLowerCase()}`}
						onClick={
							videoStatus === "REJECTED" ||
							videoStatus === null ||
							videoStatus === ""
								? () => dispatch(showVideoModal())
								: () => {}
						}
					>
						<CompliceStatus status={videoStatus} />
					</span>
				</div>
				<div className="docs">
					<h5>Proof of Address</h5>
					<span
						className={`bs-plus ${addressStatus?.toLowerCase()}`}
						onClick={
							addressStatus === "REJECTED" ||
							addressStatus === null ||
							addressStatus === ""
								? () => dispatch(showProofModal())
								: () => {}
						}
					>
						<CompliceStatus status={addressStatus} />
					</span>
				</div>

				{business_name !== "NON_REGISTERED_BUSINESS" && (
					<div className="docs">
						<h5>Certificate of Incorporation </h5>
						<span
							className={`bs-plus ${certStatus?.toLowerCase()}`}
							onClick={
								certStatus === "REJECTED" ||
								certStatus === null ||
								certStatus === ""
									? () => dispatch(showCertModal())
									: () => {}
							}
						>
							<CompliceStatus status={certStatus} />
						</span>
					</div>
				)}
			</div>
		</div>
	);
};
